export enum SiteCharViewModes {
    SitesListCollection,
    SiteChart
}
